import React from "react";
import {IProduct} from 'data/interfaces/products';
import styles from "./PlaceImageSquare.module.scss";
import {config} from "data/utils/constants";
import GenericImageSquare from "../genericImageSquare/GenericImageSquare";
import {ASSET_TYPE} from 'data/enums/assets';
import {IGuiReducerState} from 'data/redux/reducers/guiReducer';
import DesktopGallery from './components/desktopGallery';
import MobileGallery from './components/mobileGallery';
import {getPlaceDetailsName} from "data/redux/selectors/productSelector";


export interface IPlaceImageSquare {
  product: Partial<IProduct>;
  className: string;
  iconContainerClassName?: string;
  galleryOverrides?: any;
  icon?: any;
  label?: string;
  logoSrc?: string;
  logoTitle?: string;
  children?: any;
  gui?: IGuiReducerState;
}

const guiToBreakpoint = (props) => {
  try {
    if (props.gui && props.gui.breakpoints && props.gui.is) {
      for (const key in props.gui.is) {
        if (props.gui.is[key]) {
          return props.gui.breakpoints[key];
        }
      }
    }
  } catch (e) {
    console.error("Error gui to breakpoint", e);
  }
  return 480;
}

const guiIsMobile = (props) => {
  if (props.gui && props.gui.greaterThan) {
    return !props.gui.greaterThan.medium;
  }
  return false;
}


const generateAssetsList = props => (props.product.assets || [])
  .filter(({type}) => type === ASSET_TYPE.PLACE)
  .map(({asset: {sourceLink, local}}) => ({
    original: local ? sourceLink : `${config.api_server.placeImageUrl}/placephoto/${sourceLink}?maxwidth=${props.gui, guiToBreakpoint(props) + 100}`,
    thumbnail: local ? sourceLink : `${config.api_server.placeImageUrl}/placephoto/${sourceLink}?maxwidth=${props.gui, guiToBreakpoint(props) + 100}`,
    originalAlt: getPlaceDetailsName(props.product),
    thumbnailAlt: getPlaceDetailsName(props.product),
  }));

export const isThereAssetList = props => generateAssetsList(props).length > 0;

const PlaceImageSquare = (props: IPlaceImageSquare) => (
  <GenericImageSquare
    className={`${styles.PlaceImageSquare} PlaceImageSquare ${props.className}`}
    iconContainerClassName={`${props.iconContainerClassName} ${styles.iconContainerClassName}`}
    icon={props.icon}
    label={props.label}
    logoSrc={props.logoSrc}
    logoTitle={props.logoTitle}
  >
    {guiIsMobile(props) ? <MobileGallery
        images={generateAssetsList(props)}
        galleryOverrides={props.galleryOverrides}
      >
        {props.children}
      </MobileGallery> :
      <DesktopGallery
        images={generateAssetsList(props)}
        galleryOverrides={props.galleryOverrides}
      >
        {props.children}
      </DesktopGallery>}
  </GenericImageSquare>
);

PlaceImageSquare.defaultProps = {
  className: ``,
  label: 'מקום',
};

export default PlaceImageSquare;
